var _LocalLogger_level;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { store } from './../index';
import * as vega from 'vega';
export class LocalLogger {
    constructor() {
        this.warns = [];
        this.infos = [];
        this.debugs = [];
        _LocalLogger_level.set(this, 0);
    }
    level(_) {
        if (arguments.length) {
            __classPrivateFieldSet(this, _LocalLogger_level, +_, "f");
            return this;
        }
        else {
            return __classPrivateFieldGet(this, _LocalLogger_level, "f");
        }
    }
    warn(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= vega.Warn) {
            this.warns.push(...args);
        }
        return this;
    }
    info(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= vega.Info) {
            this.infos.push(...args);
        }
        return this;
    }
    debug(...args) {
        if (__classPrivateFieldGet(this, _LocalLogger_level, "f") >= vega.Debug) {
            this.debugs.push(...args);
        }
        return this;
    }
    error(...args) {
        throw new Error(...args);
        return this;
    }
}
_LocalLogger_level = new WeakMap();
export class DispatchingLogger {
    constructor() {
        this.level = (_) => {
            if (_ !== undefined) {
                store.dispatch({
                    type: 'SET_LOG_LEVEL',
                    logLevel: _,
                });
                return this;
            }
            else {
                return store.getState().logLevel;
            }
        };
        this.warn = (...args) => {
            if (this.level() >= vega.Warn) {
                console.warn(...args);
                store.dispatch({
                    type: 'WARN',
                    warn: args[0],
                });
            }
            return this;
        };
        this.info = (...args) => {
            if (this.level() >= vega.Info) {
                console.info(...args);
                store.dispatch({
                    type: 'INFO',
                    info: args[0],
                });
            }
            return this;
        };
        this.debug = (...args) => {
            if (this.level() >= vega.Debug) {
                console.debug(...args);
                store.dispatch({
                    type: 'DEBUG',
                    debug: args[0],
                });
            }
            return this;
        };
        this.error = (...args) => {
            // TODO: remove as any
            if (this.level() >= vega.Error) {
                console.warn(...args);
                store.dispatch({
                    type: 'ERROR',
                    error: 'message' in args[0] ? args[0].message : args[0],
                });
            }
            return this;
        };
    }
}
export const dispatchingLogger = new DispatchingLogger();
